import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/config";

export default function WhatsAppButton() {
    return (
        <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="floating-whatsapp"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-black shadow-[0_0_24px_rgba(37,211,102,0.45)] transition-transform hover:scale-110"
        >
            <MessageCircle size={24} />
        </a>
    );
}
